import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetAuthorArticlesLoading, EGetAuthorArticlesActionType } from './types';

export const getAuthorArticlesLoading: () => TGetAuthorArticlesLoading =
  actionGenerator<EGetAuthorArticlesActionType.Loading>(EGetAuthorArticlesActionType.Loading);
